export function createOrder(order) {
  return new Promise( async (resolve) =>{
   const response = await fetch('http://localhost:8080/orders',{
     method:'POST',
     body:JSON.stringify(order),
     headers:{'content-type':'application/json'}
   })
   const data = await response.json()
   // TODO :on server It will return only dome info of user (not password ) 
   resolve({data})
});
}

export function updateOrder(order) {
  return new Promise( async (resolve) =>{
   const response = await fetch('http://localhost:8080/orders/'+order.id,{
     method:'PATCH',
     body:JSON.stringify(order),
     headers:{'content-type':'application/json'}
   })
   const data = await response.json()
   // TODO :on server It will return only dome info of user (not password ) 
   resolve({data})
});
}


export function fetchAllOrders(pagination) {
  let queryString ="";
  for (let key in pagination) {
    queryString += `${key}=${pagination[key]}&`;
  }
    return new Promise( async (resolve) =>{
      // TODO
     const response = await fetch('http://localhost:8080/orders?'+queryString);
     const data =await response.json()
     const totalOrders = await response.headers.get('X-Total-Count') 
     resolve({data:{orders:data,totalOrders: +totalOrders}})
  }
    );
  }

